import { render, staticRenderFns } from "./FormTokenLogin.vue?vue&type=template&id=7c7d0670&scoped=true&"
import script from "./FormTokenLogin.vue?vue&type=script&lang=ts&"
export * from "./FormTokenLogin.vue?vue&type=script&lang=ts&"
import style0 from "./FormTokenLogin.vue?vue&type=style&index=0&id=7c7d0670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7d0670",
  null
  
)

export default component.exports